import axios from 'src/utils/axios';
import helpers from 'src/helpers';
import { NOTIFICATION_STATUS, SCREEN_NAMES } from 'src/constants';
import { addNotification } from 'src/actions/notificationActions';

export const SET_CUSTOMERS = '@orders/set-customers';
export const GET_CUSTOMERS = '@orders/get-customers';
export const GET_CUSTOMERS_SUCCESS = '@orders/get-customers-success';
export const GET_CUSTOMERS_ERROR = '@orders/get-customers-error';

export const UPLOAD_CSV_FOR_PARSING = '@customers/upload-csv-for-parsing';
export const UPLOAD_CSV_FOR_PARSING_SUCCESS = '@customers/upload-csv-for-parsing-success';
export const UPLOAD_CSV_FOR_PARSING_ERROR = '@customers/upload-csv-for-parsing-error';
export const IMPORT_CUSTOMERS_FROM_CSV = '@customers/import-customers-from-csv';
export const IMPORT_CUSTOMERS_FROM_CSV_SUCCESS = '@customers/import-customers-from-csv-success';
export const IMPORT_CUSTOMERS_FROM_CSV_ERROR = '@customers/import-customers-from-csv-error';
// CON-1459: Large CSV background import
export const IMPORT_CUSTOMERS_FROM_CSV_LARGE = '@customers/import-customers-from-csv-large';
export const IMPORT_CUSTOMERS_FROM_CSV_LARGE_SUCCESS = '@customers/import-customers-from-csv-large-success';
export const IMPORT_CUSTOMERS_FROM_CSV_LARGE_ERROR = '@customers/import-customers-from-csv-large-error';
export const GET_IMPORT_BATCH_STATUS = '@customers/get-import-batch-status';
export const GET_IMPORT_BATCH_STATUS_SUCCESS = '@customers/get-import-batch-status-success';
export const CLEAR_IMPORT_STATE = '@customers/clear-import-state';
export const SET_ACTIVE_IMPORT = '@customers/set-active-import';
// CON-1460: Large import background revert
export const REVERT_IMPORT_BATCH_LARGE = '@customers/revert-import-batch-large';
export const REVERT_IMPORT_BATCH_LARGE_SUCCESS = '@customers/revert-import-batch-large-success';
export const REVERT_IMPORT_BATCH_LARGE_ERROR = '@customers/revert-import-batch-large-error';

// V2 Import (Phase 10 — Contact Smart Field mapping)
export const UPLOAD_CSV_FOR_PARSING_V2 = '@customers/upload-csv-for-parsing-v2';
export const UPLOAD_CSV_FOR_PARSING_V2_SUCCESS = '@customers/upload-csv-for-parsing-v2-success';
export const UPLOAD_CSV_FOR_PARSING_V2_ERROR = '@customers/upload-csv-for-parsing-v2-error';
export const IMPORT_CUSTOMERS_FROM_CSV_V2 = '@customers/import-customers-from-csv-v2';
export const IMPORT_CUSTOMERS_FROM_CSV_V2_SUCCESS = '@customers/import-customers-from-csv-v2-success';
export const IMPORT_CUSTOMERS_FROM_CSV_V2_ERROR = '@customers/import-customers-from-csv-v2-error';
export const CLEAR_IMPORT_V2_STATE = '@customers/clear-import-v2-state';

// Contact Export
export const EXPORT_CONTACTS = '@customers/export-contacts';
export const EXPORT_CONTACTS_SUCCESS = '@customers/export-contacts-success';
export const EXPORT_CONTACTS_ERROR = '@customers/export-contacts-error';

export const GET_FOLLOW_UP_MESSAGES = '@orders/get-follow-up-messages';
export const GET_FOLLOW_UP_MESSAGES_SUCCESS = '@orders/get-follow-up-messages-success';
export const GET_FOLLOW_UP_MESSAGES_ERROR = '@orders/get-follow-up-messages-error';

export const GET_PARTIES_LIST = '@customers/get-parties-list';
export const GET_PARTIES_LIST_SUCCESS = '@customers/get-parties-list-success';
export const GET_PARTIES_LIST_ERROR = '@customers/get-parties-list-error';

export const SEND_ADD_PARTY_GUESTS = '@customers/send-add-party-guests';
export const SEND_ADD_PARTY_GUESTS_SUCCESS = '@customers/send-add-party-guests-success';
export const SEND_ADD_PARTY_GUESTS_ERROR = '@customers/send-add-party-guests-error';

export const SET_CUSTOMERS_QUERY = '@orders/set-customers-query';
export const CLEAR_CUSTOMERS_QUERY_FILTER = '@orders/clear-customers-query-filter';

export const GET_PURCHASED_PARTY_OPTIONS = '@orders/get-purchased-party-options';
export const GET_PURCHASED_PARTY_OPTIONS_SUCCESS = '@orders/get-purchased-party-options-success';
export const GET_PURCHASED_PARTY_OPTIONS_ERROR = '@orders/get-purchased-party-options-error';

export const GET_COMPANY_OPTIONS = '@orders/get-company-options';
export const GET_COMPANY_OPTIONS_SUCCESS = '@orders/get-company-options-success';
export const GET_COMPANY_OPTIONS_ERROR = '@orders/get-company-options-error';

export const SET_SELECTED_CUSTOMERS = '@orders/set-selected-customers';

export const SET_VISIBLE_MODAL_FORM_NUMBER = '@orders/set-visible-modal-form-number';

export const SET_VALUES_FORM_SEND_TEXT = '@orders/set-values-form-send-text';

export const SEND_TEXT_MESSAGE = '@orders/send-text-message';
export const SEND_TEXT_MESSAGE_SUCCESS = '@orders/send-text-message-success';
export const SEND_TEXT_MESSAGE_ERROR = '@orders/send-text-message-error';

export const SEND_ADD_TAG_CAMPAIGN = '@orders/send-add-tag-campaign';
export const SEND_ADD_TAG_CAMPAIGN_SUCCESS = '@orders/send-add-tag-campaign-success';
export const SEND_ADD_TAG_CAMPAIGN_ERROR = '@orders/send-add-tag-campaign-error';

export const SET_VALUES_FORM_ADD_PB_TAG = '@orders/set-values-form-add-pb-tag';

export const SET_VALUES_FORM_ADD_TO_PARTY = '@customers/set-values-form-add-to-party';

export const SET_VALUES_FORM_ADD_TO_GROUP = '@customers/set-values-form-add-to-group';

export const SEND_ADD_GROUP_MEMBERS = '@customers/send-add-group-members';
export const SEND_ADD_GROUP_MEMBERS_ERROR = '@customers/send-add-group-members-error';
export const SEND_ADD_GROUP_MEMBERS_SUCCESS = '@customers/send-add-group-members-success';

export const SET_VALUES_FORM_REMOVE_FROM_GROUP = '@customers/set-values-form-remove-from-group';
export const SEND_REMOVE_CONTACTS_FROM_GROUP = '@customers/send-remove-contacts-from-group';
export const SEND_REMOVE_CONTACTS_FROM_GROUP_ERROR = '@customers/send-remove-contacts-from-group-error';
export const SEND_REMOVE_CONTACTS_FROM_GROUP_SUCCESS = '@customers/send-remove-contacts-from-group-success';

export const SET_VALUES_FORM_DO_NOT_EXECUTE_SMART_ACTIONS = '@customers/set-values-form-do-not-execute-smart-actions';
export const SEND_DO_NOT_EXECUTE_SMART_ACTIONS = '@customers/send-do-not-execute-smart-actions';
export const SEND_DO_NOT_EXECUTE_SMART_ACTIONS_ERROR = '@customers/send-do-not-execute-smart-actions-error';
export const SEND_DO_NOT_EXECUTE_SMART_ACTIONS_SUCCESS = '@customers/send-do-not-execute-smart-actions-success';

export const SEND_BULK_BIRTHDAY_UPDATE = '@customers/send-bulk-birthday-update';
export const SEND_BULK_BIRTHDAY_UPDATE_ERROR = '@customers/send-bulk-birthday-update-error';
export const SEND_BULK_BIRTHDAY_UPDATE_SUCCESS = '@customers/send-bulk-birthday-update-success';

export const SEND_BULK_MODIFY_CONTACTS = '@customers/send-bulk-modify-contacts';
export const SEND_BULK_MODIFY_CONTACTS_ERROR = '@customers/send-bulk-modify-contacts-error';
export const SEND_BULK_MODIFY_CONTACTS_SUCCESS = '@customers/send-bulk-modify-contacts-success';

// CON-1521 — Contact Merge
export const GET_MERGE_CONTACTS_PREVIEW = '@customers/get-merge-contacts-preview';
export const GET_MERGE_CONTACTS_PREVIEW_SUCCESS = '@customers/get-merge-contacts-preview-success';
export const GET_MERGE_CONTACTS_PREVIEW_ERROR = '@customers/get-merge-contacts-preview-error';
export const CLEAR_MERGE_CONTACTS_PREVIEW = '@customers/clear-merge-contacts-preview';
export const SEND_MERGE_CONTACTS = '@customers/send-merge-contacts';
export const SEND_MERGE_CONTACTS_SUCCESS = '@customers/send-merge-contacts-success';
export const SEND_MERGE_CONTACTS_ERROR = '@customers/send-merge-contacts-error';

// CON-1521 — Merge history (Unmerge UI)
export const GET_MERGE_HISTORY = '@customers/get-merge-history';
export const GET_MERGE_HISTORY_SUCCESS = '@customers/get-merge-history-success';
export const GET_MERGE_HISTORY_ERROR = '@customers/get-merge-history-error';
export const SEND_UNDO_MERGE = '@customers/send-undo-merge';
export const SEND_UNDO_MERGE_SUCCESS = '@customers/send-undo-merge-success';
export const SEND_UNDO_MERGE_ERROR = '@customers/send-undo-merge-error';

// CON-1521 follow-on — Bulk Contact Merge admin tool: target-user list
export const GET_BULK_MERGE_USERS = '@customers/get-bulk-merge-users';
export const GET_BULK_MERGE_USERS_SUCCESS = '@customers/get-bulk-merge-users-success';
export const GET_BULK_MERGE_USERS_ERROR = '@customers/get-bulk-merge-users-error';

export const REPLACE_SYSTEM_GEN_MESSAGE = '@orders/replace-system-gen-message';
export const REPLACE_SYSTEM_GEN_MESSAGE_SUCCESS = '@orders/replace-system-gen-message-success';
export const REPLACE_SYSTEM_GEN_MESSAGE_ERROR = '@orders/replace-system-gen-message-error';

export const SET_BACK_TO_CUSTOMER_LIST = '@orders/set-back-to-customer-list';

export const SET_BACK_TO_PARTY_GUEST_LIST = '@orders/set-back-to-party-guest-list';
export const SET_BACK_TO_GROUP_MEMBERS_LIST = '@customers/set-back-to-group-members-list';

export const SET_BACK_TO_CHATS_LIST = '@orders/set-back-to-chats-list';

export const GET_PARTY_GUEST = '@orders/get-party-guest';
export const GET_PARTY_GUEST_SUCCESS = '@orders/get-party-guest-success';
export const GET_PARTY_GUEST_ERROR = '@orders/get-party-guest-error';

export const GET_GROUP_MEMBER = '@customers/get-group-member';
export const GET_GROUP_MEMBER_SUCCESS = '@customers/get-group-member-success';
export const GET_GROUP_MEMBER_ERROR = '@customers/get-group-member-error';

export const GET_IMPORT_BATCHES = '@orders/get-import-batches';
export const GET_IMPORT_BATCHES_SUCCESS = '@orders/get-import-batches-success';
export const GET_IMPORT_BATCHES_ERROR = '@orders/get-import-batches-error';

export const SET_IMPORT_LOG_ENTRIES = '@parties/set-import-log-entries';
export const GET_IMPORT_LOG_ENTRIES = '@orders/get-import-log-entries';
export const GET_IMPORT_LOG_ENTRIES_SUCCESS = '@orders/get-import-log-entries-success';
export const GET_IMPORT_LOG_ENTRIES_ERROR = '@orders/get-import-log-entries-error';

export const GET_IMPORT_LOG_ENTRIES_COUNTS = '@orders/get-import-log-entries-counts';
export const GET_IMPORT_LOG_ENTRIES_COUNTS_SUCCESS = '@orders/get-import-log-entries-counts-success';
export const GET_IMPORT_LOG_ENTRIES_COUNTS_ERROR = '@orders/get-import-log-entries-counts-error';

export const REVERT_IMPORT_LOG_ENTRIES = '@orders/revert-import-log-entries';
export const REVERT_IMPORT_LOG_ENTRIES_SUCCESS = '@orders/revert-import-log-entries-success';
export const REVERT_IMPORT_LOG_ENTRIES_ERROR = '@orders/revert-import-log-entries-error';

export const SET_IMPORT_LOG_ENTRIES_QUERY = '@orders/set-import-log-entries-query';
export const CLEAR_IMPORT_LOG_ENTRIES_QUERY_FILTER = '@orders/clear-import-log-entries-query-filter';

export const SET_BACK_TO_IMPORT_LOG_ENTRIES_LIST = '@orders/set-back-to-import-log-entries-list';

export const SET_SELECTED_IMPORT_LOG_ENTRIES = '@orders/set-selected-import-log-entries';

export const SET_VISIBLE_MODAL_FORM_NUMBER_IMPORT_HISTORY = '@orders/set-visible-modal-form-number-import-history';

export const SET_VISIBLE_FILTER_DROPDOWN = '@customers/set-visible-filter-dropdown';

export const getCustomers = (query = null) => async (dispatch, getState) => {
  dispatch({
    type: GET_CUSTOMERS,
  });
  try {
    const response = await axios.post('/api/contacts', query || getState()?.customers?.query || {});
    dispatch({
      type: GET_CUSTOMERS_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_CUSTOMERS_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_CUSTOMERS_ERROR,
    });
  }
};

export const uploadCSVForParsing = (fileName = '', csv = [], doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  dispatch({
    type: UPLOAD_CSV_FOR_PARSING,
  });
  try {
    const response = await axios.post('api/contacts/parse-csv', { csv });
    const payload = {
      fileName,
      fileContent: csv,
      data: response?.data || {},
    };
    dispatch({
      type: UPLOAD_CSV_FOR_PARSING_SUCCESS,
      payload
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(UPLOAD_CSV_FOR_PARSING_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: UPLOAD_CSV_FOR_PARSING_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(error, message);
    }
  }
};

export const importCustomersFromCSV = (aliases = [], doWhenTry = false, doWhenCatch = false) => async (dispatch, getState) => {
  dispatch({
    type: IMPORT_CUSTOMERS_FROM_CSV,
  });
  try {
    const { fileContent } = getState()?.customers?.customersImport?.attachedFile || {};
    const response = await axios.post('api/contacts/import-csv', { csv: fileContent, aliases });

    // Backend safety net: if the server redirected to background processing,
    // dispatch the large import success action so Redux state is correct
    if (response?.data?.redirectedToBackground) {
      dispatch({
        type: IMPORT_CUSTOMERS_FROM_CSV_LARGE_SUCCESS,
        payload: response?.data || {},
      });
    } else {
      dispatch({
        type: IMPORT_CUSTOMERS_FROM_CSV_SUCCESS,
        payload: response || {},
      });
    }

    if (doWhenTry) {
      doWhenTry(response?.data);
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(IMPORT_CUSTOMERS_FROM_CSV_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: IMPORT_CUSTOMERS_FROM_CSV_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const clearImportState = () => ({
  type: CLEAR_IMPORT_STATE,
});

// CON-1459: Large CSV background import action
export const importCustomersFromCSVLarge = (
  aliases = [],
  doWhenTry = false,
  doWhenCatch = false,
) => async (dispatch, getState) => {
  dispatch({ type: IMPORT_CUSTOMERS_FROM_CSV_LARGE });
  try {
    const { fileContent } = getState()
      ?.customers?.customersImport?.attachedFile || {};
    const response = await axios.post(
      'api/contacts/import-csv-large',
      { csv: fileContent, aliases },
    );
    dispatch({
      type: IMPORT_CUSTOMERS_FROM_CSV_LARGE_SUCCESS,
      payload: response?.data || {},
    });
    if (doWhenTry) doWhenTry(response?.data);
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(
      IMPORT_CUSTOMERS_FROM_CSV_LARGE_ERROR,
      helpers.transform.toString(message || error || 'Server error'),
      NOTIFICATION_STATUS.ERROR,
    ));
    dispatch({ type: IMPORT_CUSTOMERS_FROM_CSV_LARGE_ERROR });
    if (doWhenCatch) doWhenCatch(e);
  }
};

// CON-1459: Poll single import batch status
export const getImportBatchStatus = (batchId) => async (dispatch) => {
  try {
    const response = await axios.get(
      `/api/contacts/importbatch/${batchId}`,
    );
    dispatch({
      type: GET_IMPORT_BATCH_STATUS_SUCCESS,
      payload: response?.data || {},
    });
  } catch (e) {
    // Silently ignore polling errors
  }
};

// Check fresh CSV import status (disabled flag + pauseExecution) from DB
export const checkImportStatus = () => async () => {
  try {
    const response = await axios.get('/api/contacts/import-status');
    return response?.data || {};
  } catch (e) {
    console.error('[checkImportStatus] API call failed:', e?.message);
    return { error: true };
  }
};

// Check if user has an active import in progress
export const checkActiveImport = () => async (dispatch) => {
  try {
    const response = await axios.get('/api/contacts/active-import');
    const data = response?.data || { hasActiveImport: false };
    if (data.hasActiveImport && data.importBatchId) {
      dispatch({ type: SET_ACTIVE_IMPORT, payload: data });
    }
    return data;
  } catch (e) {
    console.error('[checkActiveImport] API call failed:', e?.message);
    return { hasActiveImport: false, error: true };
  }
};

// CON-1460: Queue background revert for large import
export const revertImportBatchLarge = (
  importBatchId,
  doWhenTry,
  doWhenCatch,
) => async (dispatch) => {
  dispatch({ type: REVERT_IMPORT_BATCH_LARGE });
  try {
    const response = await axios.post(
      '/api/contacts/revertimportlogentries-large',
      { importBatchId },
    );
    dispatch({
      type: REVERT_IMPORT_BATCH_LARGE_SUCCESS,
      payload: response?.data || {},
    });
    if (doWhenTry) doWhenTry(response?.data);
  } catch (e) {
    dispatch({ type: REVERT_IMPORT_BATCH_LARGE_ERROR });
    if (doWhenCatch) doWhenCatch(e);
  }
};

// V2 Import actions
export const uploadCSVForParsingV2 = (
  fileName = '',
  csv = [],
  doWhenTry = false,
  doWhenCatch = false,
) => async (dispatch) => {
  dispatch({ type: UPLOAD_CSV_FOR_PARSING_V2 });
  try {
    const response = await axios.post('api/contacts/parse-csv-v2', { csv });
    const payload = {
      fileName,
      fileContent: csv,
      data: response?.data || {},
    };
    dispatch({
      type: UPLOAD_CSV_FOR_PARSING_V2_SUCCESS,
      payload,
    });
    if (doWhenTry) doWhenTry();
  } catch (e) {
    const { error, message } = e?.response?.data || {};
    dispatch(addNotification(
      UPLOAD_CSV_FOR_PARSING_V2_ERROR,
      helpers.transform.toString(message || error || 'Server error'),
      NOTIFICATION_STATUS.ERROR,
    ));
    dispatch({ type: UPLOAD_CSV_FOR_PARSING_V2_ERROR });
    if (doWhenCatch) doWhenCatch(error, message);
  }
};

export const importCustomersFromCSVV2 = (
  aliases = [],
  contactSmartFieldMappings = [],
  doWhenTry = false,
  doWhenCatch = false,
  extraParams = {},
) => async (dispatch, getState) => {
  dispatch({ type: IMPORT_CUSTOMERS_FROM_CSV_V2 });
  try {
    const { fileContent } = getState()
      ?.customers?.customersImportV2?.attachedFile || {};
    const response = await axios.post('api/contacts/import-csv-v2', {
      csv: fileContent,
      aliases,
      contactSmartFieldMappings,
      ...extraParams,
    });

    if (response?.data?.redirectedToBackground) {
      dispatch({
        type: IMPORT_CUSTOMERS_FROM_CSV_LARGE_SUCCESS,
        payload: response?.data || {},
      });
    } else {
      dispatch({
        // response.data, not the whole axios response — the reducer reads
        // importBatchId/status off this payload to drive the progress banner.
        type: IMPORT_CUSTOMERS_FROM_CSV_V2_SUCCESS,
        payload: response?.data || {},
      });
    }
    if (doWhenTry) doWhenTry(response?.data);
  } catch (e) {
    const { error, message } = e?.response?.data || {};
    dispatch(addNotification(
      IMPORT_CUSTOMERS_FROM_CSV_V2_ERROR,
      helpers.transform.toString(message || error || 'Server error'),
      NOTIFICATION_STATUS.ERROR,
    ));
    dispatch({ type: IMPORT_CUSTOMERS_FROM_CSV_V2_ERROR });
    if (doWhenCatch) doWhenCatch(e);
  }
};

export const clearImportV2State = () => ({
  type: CLEAR_IMPORT_V2_STATE,
});

export const setCustomers = (customers) => ({
  type: SET_CUSTOMERS,
  payload: customers
});

export const setCustomersQuery = (query) => ({
  type: SET_CUSTOMERS_QUERY,
  payload: query
});

export const clearCustomersQueryFilter = () => ({
  type: CLEAR_CUSTOMERS_QUERY_FILTER,
});

export const getParties = () => async (dispatch) => {
  dispatch({
    type: GET_PARTIES_LIST,
  });
  try {
    const response = await axios.get('/api/parties/list');
    dispatch({
      type: GET_PARTIES_LIST_SUCCESS,
      payload: response?.data?.parties || []
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_PARTIES_LIST_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_PARTIES_LIST_ERROR,
    });
  }
};

export const sendAddPartyGuests = (addPartyGuests, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: SEND_ADD_PARTY_GUESTS,
    });
    const response = await axios.put('/api/parties/addpartyguests', { addPartyGuests });
    const { success } = response?.data || {};

    if (!success) {
      dispatch(addNotification(SEND_ADD_PARTY_GUESTS_ERROR, 'Try again later', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: SEND_ADD_PARTY_GUESTS_ERROR,
      });
      return;
    }

    dispatch(addNotification(SEND_ADD_PARTY_GUESTS_SUCCESS, 'The guests have been added.', NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: SEND_ADD_PARTY_GUESTS_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    const { message: errorMessage } = error || {};
    dispatch(addNotification(SEND_ADD_PARTY_GUESTS_ERROR, message || errorMessage || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: SEND_ADD_PARTY_GUESTS_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const setValuesFormAddToParty = (values) => ({
  type: SET_VALUES_FORM_ADD_TO_PARTY,
  payload: values
});

export const setValuesFormAddToGroup = (values) => ({
  type: SET_VALUES_FORM_ADD_TO_GROUP,
  payload: values
});

export const sendAddContactsToGroup = (groupId, addGroupMembers, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: SEND_ADD_GROUP_MEMBERS,
    });
    const { contactIds } = addGroupMembers || {};
    const isMultipleContacts = contactIds?.length > 1;

    const response = await axios.post(`/api/groups/${groupId}/members/add`, addGroupMembers);
    const { message } = response?.data || {};

    if (!message) {
      dispatch(addNotification(SEND_ADD_GROUP_MEMBERS_ERROR, 'Try again later', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: SEND_ADD_GROUP_MEMBERS_ERROR,
      });
      return;
    }

    dispatch(addNotification(SEND_ADD_GROUP_MEMBERS_SUCCESS, isMultipleContacts ? 'Selected contacts have been added.' : 'Selected contact has been added.', NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: SEND_ADD_GROUP_MEMBERS_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    const { message: errorMessage } = error || {};
    dispatch(addNotification(SEND_ADD_GROUP_MEMBERS_ERROR, message || errorMessage || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: SEND_ADD_GROUP_MEMBERS_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const setValuesFormRemoveFromGroup = (values) => ({
  type: SET_VALUES_FORM_REMOVE_FROM_GROUP,
  payload: values
});

export const sendRemoveContactsFromGroup = (groupId, contactIds, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: SEND_REMOVE_CONTACTS_FROM_GROUP,
    });
    const isMultipleContacts = contactIds?.length > 1;

    const response = await axios.post(`/api/groups/${groupId}/members/remove-by-contacts`, { contactIds });
    const { message, totalRemoved } = response?.data || {};

    if (!message) {
      dispatch(addNotification(SEND_REMOVE_CONTACTS_FROM_GROUP_ERROR, 'Try again later', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: SEND_REMOVE_CONTACTS_FROM_GROUP_ERROR,
      });
      return;
    }

    const successMessage = isMultipleContacts
      ? `${totalRemoved} contacts have been removed from the group.`
      : 'Contact has been removed from the group.';

    dispatch(addNotification(SEND_REMOVE_CONTACTS_FROM_GROUP_SUCCESS, successMessage, NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: SEND_REMOVE_CONTACTS_FROM_GROUP_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    const { message: errorMessage } = error || {};
    dispatch(addNotification(SEND_REMOVE_CONTACTS_FROM_GROUP_ERROR, message || errorMessage || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: SEND_REMOVE_CONTACTS_FROM_GROUP_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const setValuesFormDoNotExecuteSmartActions = (values) => ({
  type: SET_VALUES_FORM_DO_NOT_EXECUTE_SMART_ACTIONS,
  payload: values
});

export const sendDoNotExecuteSmartActions = (groupId, contactIds, doNotExecuteSmartActionsInGroup = true, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: SEND_DO_NOT_EXECUTE_SMART_ACTIONS,
    });
    const isMultipleContacts = contactIds?.length > 1;

    const response = await axios.put(`/api/groups/${groupId}/members/do-not-execute`, {
      contactIds,
      doNotExecuteSmartActionsInGroup,
    });
    const { message, totalUpdated } = response?.data || {};

    if (!message) {
      dispatch(addNotification(SEND_DO_NOT_EXECUTE_SMART_ACTIONS_ERROR, 'Try again later', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: SEND_DO_NOT_EXECUTE_SMART_ACTIONS_ERROR,
      });
      return;
    }

    const successMessage = isMultipleContacts
      ? `${totalUpdated} contacts have been updated.`
      : 'Contact has been updated.';

    dispatch(addNotification(SEND_DO_NOT_EXECUTE_SMART_ACTIONS_SUCCESS, successMessage, NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: SEND_DO_NOT_EXECUTE_SMART_ACTIONS_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    const { message: errorMessage } = error || {};
    dispatch(addNotification(SEND_DO_NOT_EXECUTE_SMART_ACTIONS_ERROR, message || errorMessage || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: SEND_DO_NOT_EXECUTE_SMART_ACTIONS_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const getPurchasedPartyOptions = (type) => async (dispatch) => {
  dispatch({
    type: GET_PURCHASED_PARTY_OPTIONS,
  });
  try {
    const response = await axios.post('/api/contacts/purchase-type-options', { type });
    dispatch({
      type: GET_PURCHASED_PARTY_OPTIONS_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_PURCHASED_PARTY_OPTIONS_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_PURCHASED_PARTY_OPTIONS_ERROR,
    });
  }
};

export const getCompanyOptions = () => async (dispatch) => {
  dispatch({
    type: GET_COMPANY_OPTIONS,
  });
  try {
    const response = await axios.post('/api/contacts/company-options');
    dispatch({
      type: GET_COMPANY_OPTIONS_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_COMPANY_OPTIONS_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_COMPANY_OPTIONS_ERROR,
    });
  }
};

export const setSelectedCustomers = (selectedCustomers) => ({
  type: SET_SELECTED_CUSTOMERS,
  payload: selectedCustomers
});

export const setVisibleModalFormNumber = (modalNumber) => ({
  type: SET_VISIBLE_MODAL_FORM_NUMBER,
  payload: modalNumber
});

export const setValuesFormSendText = (values) => ({
  type: SET_VALUES_FORM_SEND_TEXT,
  payload: values
});

export const sendTextMessage = (sendMessage, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: SEND_TEXT_MESSAGE,
    });
    const response = await axios.put('/api/contacts/sendmessage', { sendMessage });
    const { success } = response?.data || {};

    if (!success) {
      dispatch(addNotification(SEND_TEXT_MESSAGE_ERROR, 'Try again later', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: SEND_TEXT_MESSAGE_ERROR,
      });
      return;
    }

    dispatch(addNotification(SEND_TEXT_MESSAGE_SUCCESS, 'Your text has been scheduled to send.', NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: SEND_TEXT_MESSAGE_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    const { message: errorMessage } = error || {};
    dispatch(addNotification(SEND_TEXT_MESSAGE_ERROR, message || errorMessage || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: SEND_TEXT_MESSAGE_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const setValuesFormAddPBTag = (values) => ({
  type: SET_VALUES_FORM_ADD_PB_TAG,
  payload: values
});

export const sendAddPBTag = (addTagCampaign, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: SEND_ADD_TAG_CAMPAIGN,
    });
    const response = await axios.put('/api/contacts/addtagcampaign', { addTagCampaign });
    const { success } = response?.data || {};

    if (!success) {
      dispatch(addNotification(SEND_ADD_TAG_CAMPAIGN_ERROR, 'Try again later', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: SEND_ADD_TAG_CAMPAIGN_ERROR,
      });
      return;
    }

    dispatch(addNotification(SEND_ADD_TAG_CAMPAIGN_SUCCESS, 'The tag and/or campaign has been added.', NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: SEND_ADD_TAG_CAMPAIGN_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    const { message: errorMessage } = error || {};
    dispatch(addNotification(SEND_ADD_TAG_CAMPAIGN_ERROR, message || errorMessage || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: SEND_ADD_TAG_CAMPAIGN_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

// CON-1621 — contexts limits the picker to template scopes that can
// actually resolve on this surface's send path. Omitted means the server
// returns contact scope only (fail closed).
export const getFollowUpMessages = (contexts = null) => async (dispatch) => {
  try {
    dispatch({
      type: GET_FOLLOW_UP_MESSAGES,
    });
    const { data } = await axios.post('/api/followupmessages/template-tag', contexts ? { contexts } : {}) || {};
    const { error } = data || {};

    if (error) {
      dispatch({
        type: GET_FOLLOW_UP_MESSAGES_ERROR,
      });
      return;
    }

    dispatch({
      type: GET_FOLLOW_UP_MESSAGES_SUCCESS,
      payload: data?.messages,
    });
  } catch (e) {
    dispatch({
      type: GET_FOLLOW_UP_MESSAGES_ERROR,
    });
  }
};

export const clearFollowUpMessages = () => ({
  type: GET_FOLLOW_UP_MESSAGES_SUCCESS,
});

export const createDynamicFieldObj = async (calledFrom, selectedCustomers, selectedCustomersParties, selectedParties, selectedCustomersGroups, selectedGroups) => {
  // Check to see if all partyId elements are the same.
  const partyId = () => {
    switch (calledFrom) {
      case 'Event Guest List':
        return selectedCustomersParties.every((v, i, a) => i === 0 || v === a[i - 1]) ? selectedCustomersParties[0] : null;
      case 'Event List':
        return selectedParties.length === 1 ? selectedParties[0] : null;
      default:
        return null;
    }
  };

  const groupId = () => {
    switch (calledFrom) {
      case SCREEN_NAMES.GROUP_CONTACT_LIST:
        return selectedCustomersGroups.every((v, i, a) => i === 0 || v === a[i - 1]) ? selectedCustomersGroups[0] : null;
      case SCREEN_NAMES.GROUP_LIST:
        return selectedGroups.length === 1 ? selectedGroups[0] : null;
      default:
        return null;
    }
  };

  switch (calledFrom) {
    case 'Contact List':
      return {
        calledBy: selectedCustomers.length === 1 ? 'fillFields' : 'Client',
        screenCalledFrom: calledFrom,
        distShort: false,
        contactId: selectedCustomers.length === 1 ? selectedCustomers[0] : null,
        // partyId: selectedCustomersParties.length === 1 ? selectedCustomersParties[0] : null,
      };

    case 'Event Guest List':
      return {
        calledBy: partyId ? 'fillFields' : 'Client',
        screenCalledFrom: calledFrom,
        distShort: false,
        contactId: selectedCustomers.length === 1 ? selectedCustomers[0] : null,
        partyId: partyId(),
      };

    case 'Event List':
      return {
        calledBy: partyId ? 'fillFields' : 'Client',
        screenCalledFrom: calledFrom,
        distShort: false,
        contactId: null,
        partyId: partyId(),
      };

    case SCREEN_NAMES.GROUP_CONTACT_LIST:
      return {
        calledBy: groupId ? 'fillFields' : 'Client',
        screenCalledFrom: calledFrom,
        distShort: false,
        contactId: null,
        groupId: groupId(),
      };

    case SCREEN_NAMES.GROUP_LIST:
      return {
        calledBy: groupId ? 'fillFields' : 'Client',
        screenCalledFrom: calledFrom,
        distShort: false,
        contactId: null,
        groupId: groupId(),
      };

    default:
      return {};
  }
};

export const replaceSystemGenMessage = (systemGenMessage, dynamicFieldsObj) => async (dispatch) => {
  try {
    dispatch({
      type: REPLACE_SYSTEM_GEN_MESSAGE,
    });
    const { data } = await axios.post('/api/contacts/replace-system-gen-message', {
      systemGenMessage,
      ...dynamicFieldsObj,
    }) || {};

    dispatch({
      type: REPLACE_SYSTEM_GEN_MESSAGE_SUCCESS,
      payload: data?.message,
    });
  } catch (e) {
    dispatch({
      type: REPLACE_SYSTEM_GEN_MESSAGE_ERROR,
    });
  }
};

export const setBackToCustomerList = (payload) => ({
  type: SET_BACK_TO_CUSTOMER_LIST,
  payload,
});

export const clearBackToCustomerList = (clearAll = false) => ({
  type: SET_BACK_TO_CUSTOMER_LIST,
  payload: !clearAll ? {
    customers: [],
    query: {},
  } : false,
});

export const setBackToPartyGuestList = (payload) => ({
  type: SET_BACK_TO_PARTY_GUEST_LIST,
  payload,
});

export const setBackToGroupMembersList = (payload) => ({
  type: SET_BACK_TO_GROUP_MEMBERS_LIST,
  payload,
});

export const setBackToChatsList = (payload) => ({
  type: SET_BACK_TO_CHATS_LIST,
  payload,
});

export const clearBackToPartyGuestList = (clearAll = false) => ({
  type: SET_BACK_TO_PARTY_GUEST_LIST,
  payload: !clearAll ? {
    partyId: '',
  } : false,
});

export const getPartyGuest = (customerId, partyId) => async (dispatch) => {
  dispatch({
    type: GET_PARTY_GUEST,
  });
  try {
    const response = await axios.get(`/api/parties/${partyId}/guest/${customerId}`);
    dispatch({
      type: GET_PARTY_GUEST_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_PARTY_GUEST_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_PARTY_GUEST_ERROR,
    });
  }
};

export const getGroupMember = (customerId, groupId) => async (dispatch) => {
  dispatch({
    type: GET_GROUP_MEMBER,
  });
  try {
    const response = await axios.get(`/api/groups/${groupId}/member/${customerId}`);
    dispatch({
      type: GET_GROUP_MEMBER_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_GROUP_MEMBER_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_GROUP_MEMBER_ERROR,
    });
  }
};

export const getImportBatches = () => async (dispatch) => {
  dispatch({
    type: GET_IMPORT_BATCHES,
  });
  try {
    const response = await axios.get('/api/contacts/importbatches');
    dispatch({
      type: GET_IMPORT_BATCHES_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_IMPORT_BATCHES_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_IMPORT_BATCHES_ERROR,
    });
  }
};

export const getImportLogEntriesCounts = () => async (dispatch, getState) => {
  dispatch({
    type: GET_IMPORT_LOG_ENTRIES_COUNTS,
  });
  const importBatchId = getState().customers?.contactImportHistory?.query?.importBatchId || null;

  try {
    const response = await axios.get(`/api/contacts/importLogentries/counts/${importBatchId}`);
    dispatch({
      type: GET_IMPORT_LOG_ENTRIES_COUNTS_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_IMPORT_LOG_ENTRIES_COUNTS_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_IMPORT_LOG_ENTRIES_COUNTS_ERROR,
    });
  }
};

export const getImportLogEntries = (queryOverride = {}) => async (dispatch, getState) => {
  dispatch({ type: GET_IMPORT_LOG_ENTRIES });

  // 1) merge the override into whatever’s in Redux already
  const stateQuery = getState().customers?.contactImportHistory?.query || {};
  const rawQuery = { ...stateQuery, ...queryOverride };
  const cleaned = { ...rawQuery };

  // 2) drop invalid batch‐IDs
  if (!Number.isInteger(cleaned.importBatchId)) {
    delete cleaned.importBatchId;
  }

  // 3) if still no batch, short‐circuit to empty
  if (!cleaned.importBatchId) {
    dispatch({
      type: GET_IMPORT_LOG_ENTRIES_SUCCESS,
      payload: { importLogEntries: [] }
    });
    return { payload: { importLogEntries: [] } };
  }

  // 4) otherwise do the API call
  try {
    const response = await axios.post(
      '/api/contacts/importlogentries',
      cleaned
    );

    dispatch({
      type: GET_IMPORT_LOG_ENTRIES_SUCCESS,
      payload: response?.data || {}
    });

    return { payload: response?.data || {} };
  } catch (e) {
    const { error, message } = e?.response?.data || {};
    dispatch(addNotification(
      GET_IMPORT_LOG_ENTRIES_ERROR,
      helpers.transform.toString(message || error || 'Server error'),
      NOTIFICATION_STATUS.ERROR
    ));
    dispatch({ type: GET_IMPORT_LOG_ENTRIES_ERROR });

    return { payload: { importLogEntries: [] } };
  }
};

// Rows and counts always refresh together. The counts dropdown summarizes
// the same log entries the table shows, so refreshing one without the other
// leaves them contradicting each other on screen — which is exactly what
// happened when the refresh button fetched rows only.
export const refreshImportLogEntriesAndCounts = () => async (dispatch, getState) => {
  const importBatchId = getState().customers?.contactImportHistory?.query?.importBatchId;
  if (!Number.isInteger(importBatchId)) return;
  await Promise.all([
    dispatch(getImportLogEntries()),
    dispatch(getImportLogEntriesCounts()),
  ]);
};

export const revertImportLogEntries = (
  doWhenTry = () => { },
  doWhenCatch = () => { },
) => async (dispatch, getState) => {
  dispatch({
    type: REVERT_IMPORT_LOG_ENTRIES,
  });
  try {
    const selectedImportLogEntries = getState().customers.contactImportHistory.selectedImportLogEntries || [];
    const response = await axios.post('/api/contacts/revertimportlogentries', { selectedImportLogEntries });
    dispatch({
      type: REVERT_IMPORT_LOG_ENTRIES_SUCCESS,
      payload: response?.data || {}
    });
    if (doWhenTry) {
      await doWhenTry();
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(REVERT_IMPORT_LOG_ENTRIES_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: REVERT_IMPORT_LOG_ENTRIES_ERROR,
    });
    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const setImportLogEntries = (parties) => ({
  type: SET_IMPORT_LOG_ENTRIES,
  payload: parties
});

export const setImportLogEntriesQuery = (query) => {
  const normalizedQuery = {
    ...query,
    status: query?.status?.toLowerCase?.(), // normalize to lowercase
  };

  return {
    type: SET_IMPORT_LOG_ENTRIES_QUERY,
    payload: normalizedQuery,
  };
};

// Probably don't need - Used only for Filter By, I think.
// export const clearPartiesQueryFilter = () => ({
//   type: CLEAR_IMPORT_LOG_ENTRIES_QUERY_FILTER,
// });

export const setBackToImportLogEntriesList = (payload) => ({
  type: SET_BACK_TO_IMPORT_LOG_ENTRIES_LIST,
  payload,
});

export const clearBackToImportLogEntriesList = (clearAll = false) => ({
  type: SET_BACK_TO_IMPORT_LOG_ENTRIES_LIST,
  payload: !clearAll ? {
    parties: [],
    query: {},
  } : false,
});

export const setSelectedImportLogEntries = (selectedParties) => ({
  type: SET_SELECTED_IMPORT_LOG_ENTRIES,
  payload: selectedParties
});

export const setVisibleModalFormNumberImportHistory = (modalNumber) => ({
  type: SET_VISIBLE_MODAL_FORM_NUMBER_IMPORT_HISTORY,
  payload: modalNumber
});

export const clearSelectedCustomers = () => ({
  type: SET_SELECTED_CUSTOMERS,
  payload: []
});

export const handleFilterDropdown = (payload) => ({
  type: SET_VISIBLE_FILTER_DROPDOWN,
  payload
});

export const sendBulkBirthdayUpdate = (contactIds, contactBirthdayDefinition, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: SEND_BULK_BIRTHDAY_UPDATE,
    });
    const isMultipleContacts = contactIds?.length > 1;

    const response = await axios.put('/api/contacts/bulk-birthday-update', {
      contactIds,
      contactBirthdayDefinition,
    });
    const { updatedCount } = response?.data || {};

    if (updatedCount === undefined) {
      dispatch(addNotification(SEND_BULK_BIRTHDAY_UPDATE_ERROR, 'Try again later', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: SEND_BULK_BIRTHDAY_UPDATE_ERROR,
      });
      return;
    }

    const successMessage = isMultipleContacts
      ? `Birthday settings updated for ${updatedCount} contacts.`
      : 'Birthday settings updated for contact.';

    dispatch(addNotification(SEND_BULK_BIRTHDAY_UPDATE_SUCCESS, successMessage, NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: SEND_BULK_BIRTHDAY_UPDATE_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    // CON-1865 — this endpoint returns { error: '<text>' }, so the readable
    // text is the string itself, not error.message.
    const errorMessage = typeof error === 'string' ? error : error?.message;
    dispatch(addNotification(SEND_BULK_BIRTHDAY_UPDATE_ERROR, message || errorMessage || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: SEND_BULK_BIRTHDAY_UPDATE_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const sendBulkModifyContacts = (contactIds, changes, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: SEND_BULK_MODIFY_CONTACTS,
    });
    const isMultipleContacts = contactIds?.length > 1;

    const response = await axios.put('/api/contacts/bulk-modify', {
      contactIds,
      changes,
    });
    const { updatedCount } = response?.data || {};

    if (updatedCount === undefined) {
      dispatch(addNotification(SEND_BULK_MODIFY_CONTACTS_ERROR, 'Try again later', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: SEND_BULK_MODIFY_CONTACTS_ERROR,
      });
      return;
    }

    const successMessage = isMultipleContacts
      ? `Contact fields updated for ${updatedCount} contacts.`
      : 'Contact fields updated.';

    dispatch(addNotification(SEND_BULK_MODIFY_CONTACTS_SUCCESS, successMessage, NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: SEND_BULK_MODIFY_CONTACTS_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    const { message: errorMessage } = error || {};
    dispatch(addNotification(SEND_BULK_MODIFY_CONTACTS_ERROR, message || errorMessage || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: SEND_BULK_MODIFY_CONTACTS_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const exportContacts = (mode) => async (dispatch, getState) => {
  dispatch({ type: EXPORT_CONTACTS });
  try {
    const query = getState()?.customers?.query || {};
    const payload = {
      mode,
      query: {
        filters: query?.filters,
        search: query?.search,
        sort: query?.sort,
      },
    };
    const response = await axios.post('/api/contacts/export', payload);
    const message = response?.data?.message || 'Your contact export has been requested.';
    dispatch(addNotification(EXPORT_CONTACTS_SUCCESS, message, NOTIFICATION_STATUS.SUCCESS));
    dispatch({ type: EXPORT_CONTACTS_SUCCESS });
    return { success: true, message };
  } catch (e) {
    const { error, message } = e?.response?.data || {};
    const errorMessage = helpers.transform.toString(
      message || error || 'Could not start contact export. Please try again.',
    );
    dispatch(addNotification(EXPORT_CONTACTS_ERROR, errorMessage, NOTIFICATION_STATUS.ERROR));
    dispatch({ type: EXPORT_CONTACTS_ERROR });
    return { success: false, message: errorMessage };
  }
};

export const getExportableContactCount = () => async () => {
  try {
    const response = await axios.get('/api/contacts/export/count');
    const count = response?.data?.count;
    return typeof count === 'number' ? count : null;
  } catch (e) {
    return null;
  }
};

// CON-1521 — Contact Merge actions

export const clearMergeContactsPreview = () => ({
  type: CLEAR_MERGE_CONTACTS_PREVIEW,
});

export const getMergeContactsPreview = (contactIdA, contactIdB, keeperIdOverride = null) => async (dispatch, getState) => {
  // Issue a new requestId BEFORE the network call. Reducer increments
  // latestRequestId on START; thunk reads it back and tags SUCCESS/ERROR
  // with the same id so the reducer can drop stale responses.
  dispatch({ type: GET_MERGE_CONTACTS_PREVIEW });
  const requestId = getState()?.customers?.formMergeContacts?.latestRequestId;
  try {
    // Omit keeperIdOverride from the wire payload when null so the
    // non-override case looks identical to pre-Option-C requests.
    const body = { contactIdA, contactIdB };
    if (keeperIdOverride !== null && keeperIdOverride !== undefined) {
      body.keeperIdOverride = keeperIdOverride;
    }
    const response = await axios.post('/api/contacts/merge-preview', body);
    dispatch({
      type: GET_MERGE_CONTACTS_PREVIEW_SUCCESS,
      payload: { requestId, preview: response?.data },
    });
    return { success: true, data: response?.data };
  } catch (e) {
    const { error, message } = e?.response?.data || {};
    const errorMessage = helpers.transform.toString(
      message || error || 'Could not load merge preview. Please try again.',
    );
    dispatch({
      type: GET_MERGE_CONTACTS_PREVIEW_ERROR,
      payload: { requestId, error: errorMessage },
    });
    return { success: false, message: errorMessage };
  }
};

export const sendMergeContacts = (keepId, mergeId, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  dispatch({ type: SEND_MERGE_CONTACTS });
  try {
    const response = await axios.post('/api/contacts/merge', { keepId, mergeId });
    dispatch({
      type: SEND_MERGE_CONTACTS_SUCCESS,
      payload: response?.data,
    });
    dispatch(addNotification(
      SEND_MERGE_CONTACTS_SUCCESS,
      'Contacts merged successfully.',
      NOTIFICATION_STATUS.SUCCESS,
    ));
    if (doWhenTry) {
      doWhenTry(response?.data);
    }
    return { success: true, data: response?.data };
  } catch (e) {
    const { error, message } = e?.response?.data || {};
    const errorMessage = helpers.transform.toString(
      message || error || 'Could not merge contacts. Please try again.',
    );
    dispatch({
      type: SEND_MERGE_CONTACTS_ERROR,
      payload: errorMessage,
    });
    dispatch(addNotification(
      SEND_MERGE_CONTACTS_ERROR,
      errorMessage,
      NOTIFICATION_STATUS.ERROR,
    ));
    if (doWhenCatch) {
      doWhenCatch(e);
    }
    return { success: false, message: errorMessage };
  }
};

// CON-1521 — Merge history (Unmerge UI) thunks

export const getContactMergeHistory = () => async (dispatch) => {
  dispatch({ type: GET_MERGE_HISTORY });
  try {
    const response = await axios.get('/api/contacts/merge/history');
    dispatch({
      type: GET_MERGE_HISTORY_SUCCESS,
      payload: response?.data || [],
    });
    return { success: true, data: response?.data };
  } catch (e) {
    const { error, message } = e?.response?.data || {};
    const errorMessage = helpers.transform.toString(
      message || error || 'Could not load merge history. Please try again.',
    );
    dispatch({
      type: GET_MERGE_HISTORY_ERROR,
      payload: errorMessage,
    });
    return { success: false, message: errorMessage };
  }
};

export const sendUndoContactMerge = (mergeHistoryId, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  dispatch({ type: SEND_UNDO_MERGE });
  try {
    const response = await axios.post('/api/contacts/merge/undo', { mergeHistoryId });
    dispatch({
      type: SEND_UNDO_MERGE_SUCCESS,
      payload: response?.data,
    });
    dispatch(addNotification(
      SEND_UNDO_MERGE_SUCCESS,
      'Merge undone — the contact has been restored.',
      NOTIFICATION_STATUS.SUCCESS,
    ));
    if (doWhenTry) {
      doWhenTry(response?.data);
    }
    return { success: true, data: response?.data };
  } catch (e) {
    const { error, message } = e?.response?.data || {};
    const errorMessage = helpers.transform.toString(
      message || error || 'Could not undo merge. Please try again.',
    );
    dispatch({
      type: SEND_UNDO_MERGE_ERROR,
      payload: errorMessage,
    });
    dispatch(addNotification(
      SEND_UNDO_MERGE_ERROR,
      errorMessage,
      NOTIFICATION_STATUS.ERROR,
    ));
    if (doWhenCatch) {
      doWhenCatch(e);
    }
    return { success: false, message: errorMessage };
  }
};

// CON-1521 follow-on — Bulk Contact Merge admin: load eligible target users.
// Hits the permission-gated /api/contacts/bulk-merge/users (not the shared
// /api/account/accountlist, which 401s for non-admin/support roles and
// trips the global axios interceptor into a logout).
export const getBulkMergeUsersList = () => async (dispatch) => {
  dispatch({ type: GET_BULK_MERGE_USERS });
  try {
    const response = await axios.get('/api/contacts/bulk-merge/users');
    const users = response?.data?.users || [];
    dispatch({
      type: GET_BULK_MERGE_USERS_SUCCESS,
      payload: users,
    });
    return { success: true, users };
  } catch (e) {
    const { error, message } = e?.response?.data || {};
    const errorMessage = helpers.transform.toString(
      message || error || 'Could not load the target user list. Please try again.',
    );
    dispatch({
      type: GET_BULK_MERGE_USERS_ERROR,
      payload: errorMessage,
    });
    return { success: false, message: errorMessage };
  }
};
